import { render, staticRenderFns } from "./aduit.vue?vue&type=template&id=6b897166&scoped=true"
import script from "./aduit.vue?vue&type=script&lang=js"
export * from "./aduit.vue?vue&type=script&lang=js"
import style0 from "./aduit.vue?vue&type=style&index=0&id=6b897166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b897166",
  null
  
)

export default component.exports